<template>
    <v-card
        class="text-left"
        color="#F9F9F9">
        <v-list-item two-line>
            <v-list-item-content>
                <v-list-item-title class="headline">{{ title }}</v-list-item-title>
                <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-row justify="space-around" class="mb-2">
            <v-icon color="teal" x-large>{{ icon }}</v-icon>
        </v-row>
        <v-list class="transparent">
            <v-list-item two-line v-for="(item, index) in items" :key="index">
                <v-list-item-content :class="{'distincted': !!item.accent}">
                    <v-list-item-subtitle>{{ item.label }}</v-list-item-subtitle>
                    <v-list-item-title>{{ item.value }} <v-icon v-if="item.icon" :color="item.icon.color || 'primary'">{{ item.icon.code }}</v-icon></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-divider v-if="hasAction"></v-divider>
        <v-card-actions>
            <slot name="action"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "DataView",
        props: ["items", "title", "subtitle", "icon"],
        computed: {
            hasAction() {
                return !!this.$slots.action
            }
        }
    }
</script>

<style scoped>
.distincted {
    padding: 26px 0 9px;
    font-weight: bold;
}
</style>
